import { render, staticRenderFns } from "./SSelectSupervicevt.vue?vue&type=template&id=527aa51e"
import script from "./SSelectSupervicevt.vue?vue&type=script&lang=js"
export * from "./SSelectSupervicevt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports